<template>
	<div class="step-list"
		v-if="selectedOffer.steps !== null && selectedOffer.steps?.length && selectedOffer.steps?.length > 0"
		no-gutters>
		<div class="steps" v-for="(step, index) in selectedOffer.steps"
			:class="{ 'step-completed': step.completed, 'current-step': index === isCurrentStep }" :key="index">
			
			<div class="step step-number">
				<img v-if="step.completed" :src="AppConfigs.staticImages.GREENCHECKMARK">
				<img v-else-if="index === isCurrentStep" :src="AppConfigs.staticImages.GREENCIRCLE">
				<div v-else> {{ index + 1 }}</div>
			</div>



			<div class="step step-name">
				<span class="step-name__text">{{ step.name }}</span>

				<div class="coin-amount px-2 py-1">
					<img v-if="step.completed" :src="AppConfigs.staticImages.GREENCHECKMARK" class="mr-1">
					<CoinIcon v-else class="mr-1 coin-icon"></CoinIcon>
					<template v-if="!step.completed && getStepCoinBoost(step.coins_amount).hasActiveBoost">
						<span class="text-decoration-line-through mr-1">+{{ abbreviateNumber(getStepCoinBoost(step.coins_amount).originalCoins) }}</span>
						<span class="coin-boosted">↑{{ abbreviateNumber(getStepCoinBoost(step.coins_amount).boostedCoins) }}</span>
					</template>
					<span v-else>+{{ abbreviateNumber(step.coins_amount) }}</span>
				</div>
			</div>
			
		</div>
	</div>
</template>



<script setup lang="ts">

import { computed } from 'vue';
import CoinIcon from "@/icons/Coin.vue";
import { AppConfigs } from "@/app.configs";
import { OfferStore } from '@/store/offerStore';
import { formatLargeNumberForMobile } from '@/utils/utils';
import { calculateBoostedCoins } from '@/utils/coinBoostCalculator';
import { abbreviateNumber } from '@/utils/GlobalMethods';

const selectedOffer = computed(() => {
	return OfferStore().selectedOffer;
});

const isCurrentStep = computed(() => {
	const currentStep = selectedOffer.value.steps.findIndex(step => !step.completed);
	return currentStep === -1 ? null : currentStep;
});

const getStepCoinBoost = (coinsAmount: number) => {
	return calculateBoostedCoins(coinsAmount);
};

</script>



<style scoped lang="scss">
.coin-boosted {
	color: #F83587;
	font-weight: bold;
}
.step-list {
	width: 100%;
	overflow: hidden;
}

.steps {
	display: flex;
	align-items: center;
	z-index: 0;
	position: relative;
	width: 100%;
	font-size: 16px;
	font-weight: 600;

	@media (max-width: 600px) {
		font-size: 14px;
		font-weight: 500;
	}
}

.step {
	background-color: #2E323D;
	border: #424757 1px solid;
	border-radius: 100px;
	padding: 10px 10px 10px 10px;
	margin: 10px 0;
	width: 100%;
	box-sizing: border-box;
}

.step-name {
	flex-grow: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: calc(100% - 65px);
	box-sizing: border-box;
	margin-left: 65px;
	padding-left: 25px;

	&::before {
		content: "";
		position: absolute;
		width: 1px;
		top: -3px;
		left: 25px;
		height: 100%;
		background-color: #424757;
	}
}

.step-number {
	z-index: 2;
	position: absolute;
	width: 50px;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	margin-bottom: 0;
}

.step:first-child {
	margin-top: 0px;
}

.steps:first-child .step-name {
	margin-top: 0px;
}

.steps:first-child .step-number {
	margin-bottom: 10px;
}

.steps:last-child .step-name {
	margin-bottom: 0px;
}

.steps:last-child .step-number {
	margin-bottom: 0px;
	margin-top: 10px;
}

.step-completed>.step-name {
	background-color: #262831;
}

.step-completed>.step-number {
	background-color: #273D37;
	border: #37FA62 1px solid;
}

.step-completed .coin-amount {
	border: #273D37 1px solid;
	background-color: #273D37;
	color: #37FA62;
}

.current-step>.step-number {
	background-color: #273D37;
	border: #37FA62 1px solid;
	z-index: 5;
}

.step-completed>.step-name {
	&::before {
		content: "";
		position: absolute;
		width: 1px;
		top: 50px;
		left: 25px;
		height: 100%;
		background-color: #37FA62;
	}
}

.current-step>.step-name {
	&::before {
		content: "";
		position: absolute;
		width: 1px;
		top: 50px;
		left: 25px;
		height: 50%;
		background-color: #424757;
	}
}

.step-name__text {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	max-width: 70%;
	word-break: break-word;
	white-space: normal;
}

.coin-amount {
	display: flex;
	align-items: center;
	border: #434650 1px solid;
	border-radius: 100px;
	background-color: #434650;
	font-weight: 700;

	@media (max-width: 600px) {
		font-weight: 600;
	}
}
</style>
